<template>
    <v-card style="padding: 10px 20px;">
        <v-alert
            color="teal darken-4"
            type="info"
            outlined
            variant="tonal"
            density="compact"
            rounded="lg"
            class="custom-alert"
        >
            <strong>Why is an email address required?</strong><br>
            The member will receive a copy of this request via email for their reference and records.
        </v-alert>
        <template v-if="membEmail&&membEmail.data === null">
            <v-text-field
                key="addEmail"
                ref="email"
                v-model.trim="email"
                color="#009688"
                :rules="rules.email"
                type="email"
                clearable
                :disabled="false"
                autocomplete="nope"
                :name="`email_${randomFieldName}`"
                @keyup.enter.prevent="saveEmail"
                @blur="saveEmail"
                @paste.prevent
                @copy.prevent
                @cut.prevent
                @contextmenu.prevent
            >
                <template #label>
                    <span :style="`font-weight: 500; color: ${color.email};`">Member's Email Address</span>
                </template>
            </v-text-field>
            <v-checkbox
                v-if="membEmail && membEmail.data === null"
                key="showEmailConfirm"
                ref="emailConfirm"
                v-model="emailConfirm"
                color="teal darken-1"
                :rules="rules.emailConfirm"
                @change="changeColor('emailConfirm', 'emailConfirm')"
            >
                <template #label>
                    <span :style="`font-weight: 500; color: ${color.emailConfirm};`">I confirm that the email provided belongs to the patient: <b v-if="patientCredentials">{{ String(patientCredentials.NAME).toUpperCase() }}</b></span>
                </template>
            </v-checkbox>
        </template>
        <template v-else>
            <v-text-field
                key="showEmail"
                ref="email"
                v-model.trim="showEmail"
                color="#009688"
                :disabled="true"
            >
                <template #label>
                    <span style="font-weight: 500; color: black;">Member's Email Address</span>
                </template>
            </v-text-field>
        </template>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['data', 'patientCredentials', 'triggerChangeColor'],
    data: ()=>({
        randomFieldName: `email_${Math.random().toString(36).substr(2, 9)}`,
        color: {
            email: 'black',
            emailConfirm: 'black'
        },
        rules: {
            email: [v => !!v || 'Email Address is required' , (v) => /^[a-zA-Z0-9]+([._%-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(v) || 'E-mail Address must be valid'],
            emailConfirm: [v => !!v || 'This checkbox is required']
        },
        email: null,
        emailConfirm: null,
        showEmail: null
    }),
    computed: {
        ...mapGetters(['membEmail'])
    },
    watch: {
        triggerChangeColor() {
            this.changeColor('email', 'email')
            this.changeColor('emailConfirm', 'emailConfirm')
        },
        membEmail(newVal) {
            if (newVal.data) {
                this.email      = newVal.data
                this.showEmail  = this.censorEmail(newVal.data)
            }
        }
    },
    methods: {
        saveEmail() {
            this.changeColor('email', 'email')
            this.$emit('saveEmail', this.email)
        },
        censorEmail(email) {
            const [local, domain] = email.split('@')
            // Censor the local part
            const censoredLocal = local.length > 4
                ? `${local.slice(0, 2)}${'*'.repeat(local.length - 3)}${local.slice(-1)}`
                : local

            // Censor the domain part
            const censoredDomain = domain.length > 5
                ? `${domain.slice(0, 1)}${'*'.repeat(domain.length - 2)}${domain.slice(-1)}`
                : domain

            return `${censoredLocal}@${censoredDomain}`
        },
        changeColor(refName, colorKey) {
            this.$nextTick(() => {
                if (this.$refs && this.$refs[refName])
                    this.$refs[refName].validate() ? this.color[colorKey] = 'black' : this.color[colorKey] = 'red'
            })
        }
    }
}
</script>

<style scoped>
.custom-alert {
  color: white; /* Ensures text is readable */
  font-size: 14px; /* Adjusts text size */
}
</style>
